import {
  EVENT_CHANGE_STATUS_SUCCESS,
  EVENT_PATCH_SUCCESS,
  EVENT_SUCCESS,
} from '@pingum/app-state-management/event/types';

const scopedSuccessTypes = new Set([
  EVENT_SUCCESS,
  EVENT_PATCH_SUCCESS,
  EVENT_CHANGE_STATUS_SUCCESS,
]);

const hasOrigin = (action) => Object.prototype.hasOwnProperty.call(action, 'boardBarnId')
  || Object.prototype.hasOwnProperty.call(action, 'boardTenant');

const boardScopeMiddleware = ({ getState }) => {
  // Nested thunks keep their original scope while still passing through the middleware chain.
  const scopedThunks = new WeakSet();
  const wrapThunk = (thunk, origin) => {
    const scopedThunk = (dispatch, thunkGetState, extraArgument) => {
      const scopedDispatch = (action) => {
        if (typeof action === 'function') return dispatch(wrapThunk(action, origin));
        if (scopedSuccessTypes.has(action?.type) && !hasOrigin(action)) {
          return dispatch({
            ...action,
            ...origin,
          });
        }
        return dispatch(action);
      };
      return thunk(scopedDispatch, thunkGetState, extraArgument);
    };
    scopedThunks.add(scopedThunk);
    return scopedThunk;
  };

  return (next) => (action) => {
    if (typeof action !== 'function' || scopedThunks.has(action)) return next(action);
    const barn = getState().barn?.selectedBarn;
    return next(wrapThunk(action, {
      boardBarnId: barn?.id,
      boardTenant: barn?.tenant,
    }));
  };
};

export default boardScopeMiddleware;
